@if (!!site) {
  <div
    class="position-relative d-none d-md-block animate__animated animate__slideInLeft animate__faster bg-info ziro-left-nav"
  >
    <div class="sidebar">
      <!-- Avatar (some LDAP users have no photo so we need to evaluate the photo itself not the user type) -->
      @if (getBase64Photo()) {
        <div class="no-margin text-center">
          <!-- Images get loaded before ng-if hides them, so we need to do this -->
          <a [href]="getUser360ViewRoute()">
            <img class="avatar-pic" [src]="getImageSrc()" />
          </a>
        </div>
      }
      <!-- Contact Card -->
      <div class="contact-card border-rad-all-2">
        @if (!getBase64Photo()) {
          <a [href]="getUser360ViewRoute()" class="text-white">
            <i [class]="ziroIcons.CIRCLE_USER" class="fa-3x"></i>
          </a>
        }
        <br />
        <span id="username" data-automation="user-detail-card-username" class="font-bold small">
          <a data-automation="user-detail-card-username-link" [href]="getUser360ViewRoute()">
            {{ getUsername() }}
          </a>
        </span>
        <h5 data-automation="user-detail-card-name" class="no-margin">
          <span class="font-light">
            {{ getFullName() }}
          </span>
        </h5>
        <hr />
        <span [hidden]="!getEmail()">
          <a data-automation="user-detail-card-email" href="mailto:{{ getEmail() }}">
            {{ getEmail() }}
          </a>
          <br />
        </span>
        <ziro-dn-detail-summary-info
          [translationPatternRef]="translationPatterns"
          [directoryNumberRef]="directoryNumber"
        ></ziro-dn-detail-summary-info>
        <!--Site-->
        @if (areClustersConfigured) {
          <div data-automation="user-detail-card-site-section">
            <span [class]="ziroIcons.SITE" class="me-1"></span>
            <span data-automation="user-detail-card-site-name" id="site-name">{{ site?.name }}</span>
            <br />
          </div>
        }
        <!--LDAP-->
        <span [hidden]="getLdapType() === 'LOCAL'" data-automation="user-detail-card-ldap-status" id="ldap-status">
          <div>
            <span class="badge bg-success" [hidden]="getLdapType() !== 'LDAP_ACTIVE'">
              <i [class]="ziroIcons.USER"></i>
              <span class="ms-1">{{ 'tkey;userdetail.nav.user_type.active_ldap.text' | translate }}</span>
            </span>
            <span class="badge bg-warning" [hidden]="getLdapType() !== 'LDAP_INACTIVE'">
              <i [class]="ziroIcons.USER"></i>
              <span>{{ 'tkey;userdetail.nav.user_type.inactive_ldap.text' | translate }}</span>
            </span>
          </div>
          @for (item of global360View.ldapUser?.additionalAttributes | keyvalue; track item; let i = $index) {
            <span>
              @if (!!item.value) {
                <span
                  [ngbTooltip]="item.key"
                  [tooltipClass]="'tooltip--white'"
                  [container]="'body'"
                  data-automation="ldap-additional-attribute"
                  [ngClass]="'ldap-additional-attribute-' + i"
                >
                  {{ item.value }}
                </span>
              }
              @if (!!item.value) {
                <br />
              }
            </span>
          }
        </span>
        <span
          [hidden]="getLdapType() !== 'LOCAL'"
          class="badge bg-secondary"
          data-automation="user-detail-card-ldap-non-status"
          id="non-ldap-status"
        >
          <span>{{ 'tkey;userdetail.nav.user_type.local.text' | translate }}</span>
        </span>
      </div>
      @if (areClustersConfigured) {
        <ziro-operations-menu
          (pinResetClicked)="onPinResetClick()"
          (makePublicClicked)="onMakePublicClick()"
          (changeSiteClicked)="onChangeSiteClick()"
          (reassignClicked)="onReassignClick()"
          (sendEmailClicked)="onSendEmailClick($event)"
        ></ziro-operations-menu>
      }
    </div>
  </div>
}
